import { defineMessages } from 'react-intl';

export default defineMessages({
  period: {
    id: 'dayCalendar.period',
    defaultMessage: '{day}, {month} %28{weekDay}%29 {year}',
  },
});
